import {
  IPublicationReportEmbedAttribute,
  IPublicationReportEmbedCookie,
  IStoryCookie,
  IStoryCookieAttribute
} from '../../types/storyListTypes';

// return the new cookies value based on different field
export const getNewCookieValue = (cookie: IStoryCookie, attribute: IStoryCookieAttribute, value: string): IStoryCookie => {
  return { ...cookie, [attribute]: value };
};

// return the new cookies value based on different field of report embeds control bar
export const getNewReportEmbedCookieValue = (
  cookie,
  attribute: IPublicationReportEmbedAttribute,
  value: string
): IPublicationReportEmbedCookie => {
  return { ...cookie, [attribute]: value };
};
